import i18n from "i18next";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector).init({
    supportedLngs: ['pl', 'en', 'de'],
    detection: {
        order: ['path'],
        lookupFromPathIndex: 0,
        convertDetectedLanguage: (lng) => lng.replace('lang-', '')
    }
});

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        fallbackLng: "en", // use en if detected lng is not available
        saveMissing: false, // send not translated keys to endpoint
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?version=20250529113000`
        }
    });

export default i18n;